import {useIsAuthenticated, useMsal} from '@azure/msal-react'
import {useSignal, useSignals} from '@preact/signals-react/runtime'
import {Dialog} from 'primereact/dialog'
import {forwardRef, useCallback, useImperativeHandle} from 'react'
import {
    blockOverflownScroll,
    unblockOverflownScroll,
} from '../../utils/BlockScrollsUtils'
import GenericError from './GenericError'
const GenericPageError = forwardRef((props, ref) => {
    useSignals()
    useImperativeHandle(ref, () => ({
        showForm: handleShowForm,
        hideForm: handleHideForm,
    }))

    const isAuthenticated = useIsAuthenticated()
    const {instance} = useMsal()

    const visible = useSignal(false)
    const type = useSignal(null)

    const handleShowForm = useCallback(
        value => {
            type.value = value
            visible.value = true
            blockOverflownScroll()
        },
        [type, visible],
    )

    const handleHideForm = useCallback(() => {
        type.value = null
        visible.value = false
        unblockOverflownScroll()

        if (!!isAuthenticated) {
            instance?.logout()
        }
    }, [type, visible, isAuthenticated, instance])

    return (
        <div>
            <Dialog
                header=""
                style={{minWidth: '40vw'}}
                breakpoints={{'960px': '75vw', '641px': '100vw'}}
                visible={visible.value}
                onHide={() => handleHideForm()}>
                {!!type.value && (
                    <GenericError
                        type={type.value}
                        onClose={() => handleHideForm()}
                    />
                )}
            </Dialog>
        </div>
    )
})

export default GenericPageError
